<template>
  <div id="app">
    <!-- <router-view name="header" /> -->
    <div class="wrapper">
      <router-view />
    </div>
    <!-- <router-view name="footer" /> -->
  </div>
</template>
<script>
export default {
  
};
</script>
<style >
.form-control {
  border-radius: 5px;
}

.wrapper {
  background: #f0f0f0;
}
</style>
